import { HttpResponse } from '@tda/utilities';
import { ProductInfo } from '../domain-models/product-info.model';
import { ChatClient } from './chat-http-client';

export async function updateUserProducts(userProducts: Array<string>): Promise<HttpResponse<Array<ProductInfo>>> {
  return await ChatClient.put<Array<ProductInfo>>(`/products`, { products: userProducts });
}
